import axios from 'axios'

// Axios instance for the TradeGrid Admin Auth service.

const host = (process.env.REACT_APP_ADMIN_AUTH_BASE_URL || '').replace(/\/+$/, '')

if (!host && process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn(
    '[adminAuthApi] REACT_APP_ADMIN_AUTH_BASE_URL is not set. Admin management ' +
    'requests will resolve against the app origin and fail.',
  )
}

const USE_BEARER_PREFIX = true

const adminAuthApi = axios.create({
  baseURL: `${host}/api/v1`,
  headers: { 'Content-Type': 'application/json' },
})

adminAuthApi.interceptors.request.use((config) => {

  const stored = localStorage.getItem('__TG')

  if (stored && stored !== 'null') {
    try {
      const token = JSON.parse(stored)?.token
      if (token) {
        config.headers.Authorization = USE_BEARER_PREFIX ? `Bearer ${token}` : token
      }
    } catch {
      // Ignore JSON parse errors
    }
  }

  return config
})


adminAuthApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const envelope = error?.response?.data
    const message =
      envelope?.message ||
      error?.message ||
      'Something went wrong talking to the admin auth service.'

    const normalised = new Error(message) as Error & {
      status?: number
      code?: number
      original?: unknown
    }
    normalised.status = error?.response?.status
    normalised.code = envelope?.code
    normalised.original = error

    return Promise.reject(normalised)
  },
)

export default adminAuthApi
